import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

import { VbBaseMenuComponent } from './VbBaseMenu.Component';
import { VbControlBarFocusDirective } from './VbControlBarFocus.Directive';
import { VbNestedMenuComponent } from './VbNestedMenuComponent';
import { VbResizedDirective } from './VbResize.Directive';
import { ControlDisplayDirective } from 'vbrick-player-src/ControlDisplay.Directive';

const components = [
	ControlDisplayDirective,
	VbBaseMenuComponent,
	VbControlBarFocusDirective,
	VbNestedMenuComponent,
	VbResizedDirective
];

@NgModule({
	declarations: components,
	exports: components,
	imports: [
		CommonModule,
		BsDropdownModule
	]
})
export class SharedModule {}
